import React from 'react';
import { Route, useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { checkIfUser } from '../../services/authSer';
import { getUserData } from '../../services/userSer';

function ProtectedRoute(props) {
  let history = useHistory();

  const checkTokenUser = async () => {
    let data = await checkIfUser()
    console.log(data);
  
    // check if this is bussiness route
    if(props.bizRoute){
      // getting data from service to check afterwards if this user is biz
      let user = getUserData();
      // checking if this user is biz
      if(!user.biz){
        toast.warning("You must be business");
        history.push("/");
      }
    }

    //if everything ok we getting status otherwise:
    if (!data.status) {
      toast.error("There problem, log in again");
      // למחוק את הטוקן אם הוא לא תקין
      localStorage.removeItem("tok");
      history.push("/login");
    }
  }

  return (
    <Route exact path={props.path}
      render={() => {
        // check if user's token exists and valid
        checkTokenUser();
        return (<props.comp {...props}/>);
      }} />
  )
}

export default ProtectedRoute;